export const getAssignDeliverable = state => state.deliverableAssign.get('deliverable');
export const getDeliverableId = state => state.deliverableAssign.getIn(['deliverable', 'id']);



/** WEBPACK FOOTER **
 ** ./src/selectors/deliverable-assign-selectors.js
 **/